import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { REDIRECT_URL, ASSET_PREFIX } from '../config/constants';

import bullet from '../images/hexagon-bullet.png';
import hamburger from '../images/hamburger.svg';

import '../styles/Header.css';

import { signout, initApp, toggleNav, fetchTags } from '../actions/index';

const isStage = window.location.hostname.indexOf('stage') > 0;
const BASE_PATH = isStage
  ? 'https://hippostage.silverorange.com/hippo-pa/work-pa-qbank/www'
  : 'http://www.hippoed.com';
const PA_BASE = isStage ? BASE_PATH : `${BASE_PATH}/pa`;

const dropdownColumns = [
  [
    {
      header: 'EMERGENCY MEDICINE',
      items: [
        {
          header: 'EM Board Review',
          color: '#ea4c37',
          link: `${BASE_PATH}/em/boardreview`,
          description: 'Video lectures, adaptive Qbank & CME'
        },
        {
          header: 'ERcast Podcast',
          color: '#ea4c37',
          link: `https://home.hippoed.com/em/ercast`,
          description: 'Weekly EM audio on medicine and life'
        },
        {
          header: 'EM Qbank',
          color: '#ea4c37',
          link: `${BASE_PATH}/em/qbank`,
          description: 'Adaptive Qbank with 1350+ ABEM-style questions'
        },
        {
          header: 'EM Board Review Resident Package',
          color: '#ea4c37',
          link: `${BASE_PATH}/em/resident`,
          description: 'Video lectures & adaptive Qbank for residents'
        },
        {
          header: 'EM LLSA Prep',
          color: '#ea4c37',
          link: `${BASE_PATH}/em/llsa`,
          description: 'LLSA prep & MOC'
        },
        {
          header: 'Cardiology CME',
          color: '#ea4c37',
          link: `${BASE_PATH}/em/cardiology`,
          description: 'Cardiology-specific CME with the top papers of the year from Amal Mattu.'
        },
        {
          header: 'Essentials of Emergency Medicine 2023',
          color: '#ea4c37',
          link: ' https://home.hippoed.com/essentialsofem',
          description: 'Get ready for the upcoming Essentials 2023 conference'
        },
        {
          header: 'Essentials of Emergency Medicine 2022',
          color: '#ea4c37',
          link: ' https://home.hippoed.com/essentialsofem2022',
          description: 'Experience the on-demand digital packages from EEM 2022'
        },
        {
          header: 'Essentials of Emergency Medicine Archives',
          color: '#ea4c37',
          link: 'https://www.essentialsofem.com',
          description: 'Live EM conference and on-demand digital packages'
        },
        {
          header: 'Essentials of EMCrit',
          color: '#ea4c37',
          link: 'https://www.essentialsofem.com/course/eemcrit',
          description: 'The best critical care event of the year'
        },
      ]
    }
  ],
  [
    {
      header: 'TELEMEDICINE',
      items: [
        {
          header: 'Telemedicine: Common Conditions',
          color: '#3b38dd',
          link: `https://www.hippoed.com/telemedicine-commonconditions`,
          description: 'On-demand video course to expand clinical practices into telemedicine'
        }
      ]
    },
    {
      header: 'BOOTCAMPS',
      items: [
        {
          header: 'Adult EM Bootcamp',
          color: '#ea4c37',
          link: `https://home.hippoed.com/adult-em-bootcamp`,
          description: 'On-demand video onboarding course for the ED'
        },
        {
          header: 'Peds EM Bootcamp',
          color: '#ea4c37',
          link: `https://www.hippoed.com/em/pem-bootcamp`,
          description: 'On-demand pediatric clinical care certification'
        },
        {
          header: 'Urgent Care Bootcamp',
          color: '#18ae5c',
          link: `https://home.hippoed.com/urgentcare/bootcamp`,
          description: 'The only video course truly created for the urgent care setting'
        },
        {
          header: 'Primary Care Bootcamp: Adult',
          color: '#3295d2',
          link: `https://home.hippoed.com/adult-primary-care-bootcamp`,
          description: 'Confidently manage the complexity of a busy primary care practice'
        },
        {
          header: 'Primary Care Bootcamp: Peds',
          color: '#3295d2',
          link: `https://home.hippoed.com/pediatric-primary-care-bootcamp`,
          description: 'Confidently manage the complexity of a busy pediatric primary care practice'
        }
      ]
    },
    {
      header: 'PEDIATRICS',
      items: [
        {
          header: 'Peds Board Review',
          color: '#9459a4',
          link: `${BASE_PATH}/peds/boardreview/`,
          description: 'Video lectures, adaptive Qbank & CME'
        },
        {
          header: 'Peds Reviews and Perspectives',
          color: '#9459a4',
          link: `https://home.hippoed.com/peds/rap/`,
          description: 'Monthly Pediatrics podcast with CME'
        },
        {
          header: 'Peds Qbank',
          color: '#9459a4',
          link: `${BASE_PATH}/peds/qbank/`,
          description: 'Adaptive Qbank with 1250+ ABP®-format questions'
        },
        {
          header: 'Peds Foundations',
          color: '#9459a4',
          link: `${BASE_PATH}/peds/foundations/`,
          description: 'Comprehensive, on-demand video course'
        },
        {
          header: 'Peds residents',
          color: '#9459a4',
          link: `${BASE_PATH}/peds/resident/`,
          description: 'Video lectures & adaptive Qbank for residents'
        }
      ]
    }
  ],
  [
    {
      header: 'PA',
      items: [
        {
          header: 'AAPA Primary Care RAP',
          color: '#3295d2',
          link: 'https://home.hippoed.com/pa/aapa-primarycare-rap',
          description: 'Monthly PA Primary Care podcast with CME'
        },
        {
          header: 'AAPA PANCE/PANRE Review',
          color: '#3295d2',
          link: `${PA_BASE}/aapa-review/`,
          description: 'PA on-demand PANCE/PANRE review with CME'
        },
        {
          header: 'AAPA Qbank',
          color: '#3295d2',
          link: `${PA_BASE}/aapa-qbank/`,
          description: 'Adaptive Qbank with 1800+ NCCPA-style questions'
        },
        {
          header: 'AAPA General Practice Self‑Assessment',
          color: '#3295d2',
          link: `${PA_BASE}/aapa-assessment/`,
          description: 'PA Self–Assessment with CME'
        },
        {
          header: 'AAPA Emergency Medicine Self-Assessment',
          color: '#3295d2',
          link: `${PA_BASE}/aapa-em-assessment/`,
          description: 'PA Self-Assessment with CME'
        },
        {
          header: 'AAPA End of Rotations Practice Exams',
          color: '#3295d2',
          link: `https://home.hippoed.com/pa/aapa-eor-practice-exams`,
          description: 'The most effective way to master your clinical rotations and ace your EOR exams.'
        }
      ]
    },
    {
      header: 'PRIMARY CARE',
      items: [
        {
          header: 'Primary Care Reviews and Perspectives',
          color: '#3295d2',
          link: `https://home.hippoed.com/primarycare/rap/`,
          description: 'Monthly Primary Care podcast with CME'
        }
      ]
    },
    {
      header: 'URGENT CARE',
      items: [
        {
          header: 'Urgent Care Reviews and Perspectives',
          color: '#18ae5c',
          link: `https://home.hippoed.com/urgentcare/rap`,
          description: 'Monthly Urgent Care podcast with CME'
        },
        {
          header: 'Urgent Care LLSA',
          color: '#18ae5c',
          link: `${BASE_PATH}/uc-llsa`,
          description: 'Lifelong Learning Self Assessment'
        }
      ]
    }
  ]
];

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  render() {
    const brand = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-Qbank-logo.png`)
      : require(`../images/logo-navbar@2x.png`);
    return (
      <div className="header">
        <div className="header-content">
          {this.props.user ? (
            <div
              onTouchTap={() =>
                !this.props.navOpen ? this.props.toggleNav() : null
              }
              className={`${
                this.props.currentState === 'walkthrough' ? 'hide ' : ''
              }mobile-menu show-on-mobile${
                this.props.navOpen ? ' nav-open' : ''
              }`}
            >
              <img alt="" src={hamburger} />
            </div>
          ) : null}
          <ul className="header-always-visible">
            <li className="logos">
              <ul>
                <li>
                  <img
                    style={this.props.user ? { marginRight: '47px' } : {}}
                    src={brand}
                    alt="Hippo Education"
                  />
                </li>
              </ul>
            </li>
            <li
              className={`${
                this.props.user ? 'hide-on-mobile ' : ''
              }dropdown-and-signin-buttons`}
            >
              <ul>
                <li>
                  <div
                    className="dropdown-toggle-text-container hide-on-mobile"
                    onClick={() => this.setState({ open: !this.state.open })}
                  >
                    <div className="more-education">More Education</div>
                    <div className="from-hippo">from Hippo</div>
                  </div>
                </li>
                <li>
                  {this.props.user || this.props.authToken ? null : (
                    <div className="divider">
                      <a
                        href={
                          process.env.REACT_APP_MOBILE_TEST
                            ? '#'
                            : REDIRECT_URL + this.props.params.pathfix
                        }
                        onClick={() =>
                          process.env.REACT_APP_MOBILE_TEST
                            ? this.props
                                .initApp()
                                .then(() => this.props.fetchTags())
                            : null
                        }
                        className="signin"
                      >
                        Sign In
                      </a>
                    </div>
                  )}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          className="header-dropdown hide-on-mobile"
          ref="dropdown"
          style={{ maxHeight: this.state.open ? '600px' : '0px' }}
        >
          {/* NOTE 336px was found empirically - if this starts changing more
             * often then we can make this happen dynamically, but it isn't a 2
             * minute fix. Also, using 'initial' will not work with animcations
             */}
          <ul className="dropdown-columns">
            {dropdownColumns.map((column, index) => {
              return (
                <li key={index}>
                  <ul>
                    {column.map((section, index) => {
                      return (
                        <li key={index} className="section">
                          <div className="section-header">{section.header}</div>
                          <ul>
                            {section.items.map((item, index) => {
                              return (
                                <li key={index} className="dropdown-bullet">
                                  <img
                                    alt=""
                                    src={bullet}
                                    style={{ backgroundColor: item.color }}
                                  />
                                  <div className="content">
                                    <a href={item.link} target="_blank">
                                      {item.header}
                                    </a>
                                    <small>{item.description}</small>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const user = state.app ? state.app.user : null;
  const navOpen = state.app ? state.app.navOpen : null;
  return {
    product: state.app ? state.app.product : null,
    user,
    navOpen,
    currentState: state.currentState ? state.currentState.state : null,
    authToken: state.auth ? state.auth.accessToken : null
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { initApp, signout, toggleNav, fetchTags },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header.js